<app-topstrip></app-topstrip>

<main style="margin-top: 100px;    background-color: #f4f7fb;
    min-height: calc(100% - 100px);
">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
